import React from 'react'

// MSP Lib Components
import { BaseDynamicTag as DynamicTag } from './DynamicTag'

const DynamicTagDemo = () => {
  return (
    <>
      <div className='my-3 font-bold'>Headline Tags</div>
      <ul>
        <li>
          <DynamicTag componentTagName='Headline'>
            This is H1 Headline
          </DynamicTag>
        </li>
        <li>
          <DynamicTag componentTagName='Headline' tag='h2' uppercase={true}>
            This is H2 Headline with uppercase=true
          </DynamicTag>
        </li>
        <li>
          <DynamicTag componentTagName='Headline' tag='h3' fontFamily='wide'>
            This is H3 Headline with fontFamily=wide
          </DynamicTag>
        </li>
        <li>
          <DynamicTag componentTagName='Headline' tag='h4' href='/cart'>
            This is H4 Headline with an href link
          </DynamicTag>
        </li>
        <li>
          <DynamicTag
            componentTagName='Headline'
            tag='h5'
            textPosition='center'
          >
            This is H5 Headline with textPosition=center
          </DynamicTag>
        </li>
        <li>
          <DynamicTag
            componentTagName='Headline'
            tag='h6'
            colorScheme='secondary'
          >
            This is H6 Headline with colorScheme=secondary
          </DynamicTag>
        </li>
      </ul>

      <div className='my-3 font-bold'>Preline</div>
      <DynamicTag componentTagName='Preline'>
        This a Preline Component
      </DynamicTag>
      <DynamicTag
        componentTagName='Preline'
        colorScheme='secondary'
        textPosition='center'
        className='p-2'
      >
        This a Preline Component (secondary)
      </DynamicTag>

      <div className='my-3 font-bold'>Tags/Labels</div>
      <DynamicTag componentTagName='Tag'>Röstung</DynamicTag>
      <DynamicTag componentTagName='Tag' className='mx-2'>
        Intensität
      </DynamicTag>
      <DynamicTag
        componentTagName='Tag'
        colorScheme='secondary'
        className='mx-2 px-4 py-2'
      >
        Expand
      </DynamicTag>
      <DynamicTag
        componentTagName='Tag'
        colorScheme='secondary'
        className='mx-2 px-4 py-2'
      >
        Scroll down
      </DynamicTag>

      <div className='my-3 font-bold'>Footnotes</div>
      <DynamicTag componentTagName='Footnotes'>
        Sample: *Alle Preise inkl. MwSt. zzgl. Versandkosten
      </DynamicTag>
      <DynamicTag componentTagName='Footnotes' className='bg-coffee1-50 p-4'>
        Sample: *Alle Preise inkl. MwSt. zzgl. Versandkosten
      </DynamicTag>
      <DynamicTag
        componentTagName='Footnotes'
        colorScheme='secondary'
        className='bg-machine4-100 my-2 p-4'
      >
        Sample: *Alle Preise inkl. MwSt. zzgl. Versandkosten (for darker
        background)
      </DynamicTag>
    </>
  )
}

export default DynamicTagDemo
